import dayjs from 'dayjs';

export default function getAge(dateString) {
	const dateObject = dayjs(new Date());
	return dateObject.diff(dayjs(dateString), 'year');
}
